import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Accordion } from "react-bootstrap";
import BaseProductCategoryAccordion from "./BaseProductCategoryAccordion";
import AccordionProductListItem from "./AccordionProductListItem";
import { pointsOfInterestToggle } from "actions";

const POINTSOFINTEREST_ITEMS = [
  {
    name: "biospheres",
    label: "UN Biospheres",
    description:
      "The Man and the Biosphere (MAB) programme is UNESCO’s leading initiative in biodiversity conservation and sustainable development by enhancing the relationship between people and their environments.",
  },
];

const PointsOfInterestAccordion = () => {
  const dispatch = useDispatch();
  const pointsofinterest_active = useSelector(
    (state) => state.pointsofinterest_active
  );
  const { t } = useTranslation();

  const onPointsOfInterestClick = (name, active) => {
    dispatch(pointsOfInterestToggle(name, !active));
  };

  return (
    <Accordion defaultActiveKey="2">
      <BaseProductCategoryAccordion
        categoryLabel={t("Points of Interest")}
        selectionsCount="0"
        eventKey="0"
      >
        <div>
          {POINTSOFINTEREST_ITEMS.map((product) => (
            <AccordionProductListItem
              key={product.name}
              product={product}
              active={pointsofinterest_active.includes(product.name)}
              selectionCallback={() =>
                onPointsOfInterestClick(
                  product.name,
                  pointsofinterest_active.includes(product.name)
                )
              }
            />
          ))}
          ;
        </div>
      </BaseProductCategoryAccordion>
    </Accordion>
  );
};

export default PointsOfInterestAccordion;
